import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=03b28c28"
import script from "./StatusInfo.vue?vue&type=script&lang=js"
export * from "./StatusInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports